
















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { Prop } from 'vue-property-decorator'
import { AdminDepositRoute } from '@/modules/deposit/routes/admin-deposit.route'

@Component({
  components: {
    BaseButton
  }
})
export default class AdminDepositCreateButton extends Vue {
  constructor(
    private readonly routes: AdminDepositRoute
  ) {
    super()
  }

  @Prop({ default: 'جدید' }) label?: string

}
